import { allClientSideFlags } from '@gonfalon/constants/constants';
import type { LDClient as LDClientV4 } from '@launchdarkly/js-client-sdk';
import type { LDClient as LDClientV3 } from 'launchdarkly-js-client-sdk';

import { createDogfoodClient as createDogfoodClientV3 } from './internal/dogfoodClientV3';
import { createDogfoodClient as createDogfoodClientV4 } from './internal/dogfoodClientV4';

let dogfoodClient: LDClientV3 | LDClientV4 | undefined;
let isV4Client: boolean | undefined;

/**
 * DO NOT USE. For testing purposes only.
 */
export function resetDogfoodClient() {
  dogfoodClient = undefined;
  isV4Client = undefined;
}

export function isDogfoodClientV4(): boolean {
  if (dogfoodClient === undefined) {
    return allClientSideFlags()?.['use-js-client-sdk-v4'] === true;
  }
  return isV4Client === true;
}

export function getDogfoodClient() {
  if (!dogfoodClient) {
    const useV4 = allClientSideFlags()?.['use-js-client-sdk-v4'] === true;
    if (useV4) {
      dogfoodClient = createDogfoodClientV4();
      isV4Client = true;
    } else {
      dogfoodClient = createDogfoodClientV3();
      isV4Client = false;
    }
  }

  return dogfoodClient;
}
